/* eslint-disable indent */
import {
  buildNtbColumns,
  NtbTooltipValues
} from '~/modules/retailMedia/helpers/ntbMetrics'

import { toggleValueByStatus } from './helpers'

type AdRow = { status?: string; metrics?: Record<string, unknown> }

/**
 * Colunas de NTB do grão de anúncio: tooltip próprio (`*Ad`) avisa que a
 * soma das linhas não reproduz o número da campanha.
 */
export const ntbAdColumns = ({
  availableMetrics,
  ntbValues
}: {
  availableMetrics?: NewMetricsAvailability
  ntbValues: NtbTooltipValues
}) =>
  buildNtbColumns<AdsResultFormatted>({
    availableMetrics,
    ntbValues,
    variant: 'ad',
    render:
      metric =>
      ({ status, metrics }: AdRow) =>
        toggleValueByStatus(status, metrics?.[metric.key])
  })
